import Serve from '@/views/Serve'
import CreateServe from '@/views/serve/CreateServe'
import ServePage from '@/views/serve/ServePage'
import ServiceWorks from '@/views/ServiceWorks'
import CreateServiceWork from '@/views/serviceWorks/Create'
import UpdateServiceWork from '@/views/serviceWorks/Update'

export default [
  {
    path: '/serve/:carId/create',
    component: CreateServe,
    props: true,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/serve/:carId',
    component: ServePage,
    name: 'servePage',
    props: true,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/serve',
    component: Serve,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/service-works',
    component: ServiceWorks,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/service-works/create',
    component: CreateServiceWork,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }, {
    path: '/service-works/update/:id',
    component: UpdateServiceWork,
    props: true,
    meta: {
      title: 'Тех. обслуживание',
      layout: 'BaseWorkspaceLayout'
    }
  }
]
